<json-editor
  class="json-editor-component"
  *ngIf="showEditor"
  [options]="editorOptions"
  [data]="initialData"
  (change)="showJson($event)"
></json-editor>
